import { useEffect, useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const FIELDS = [["name", "Nom / société"], ["street", "Adresse"], ["zip", "Code postal"], ["city", "Ville"], ["phone", "Téléphone"], ["email", "Email"]];

function Status({ ok, label, need }) {
  return (
    <div className="flex items-start gap-3 rounded-sm border border-[var(--line)] bg-[var(--ink-2)] p-5">
      {ok ? <CheckCircle2 className="h-5 w-5 text-emerald-400" /> : <XCircle className="h-5 w-5 text-[var(--muted)]" />}
      <div>
        <p className="font-display text-xl">{label}</p>
        <p className="mt-1 text-sm text-[var(--muted)]">{ok ? "Connecté — génération d'étiquettes active." : `En attente : ${need}`}</p>
      </div>
    </div>
  );
}

export function ShippingSettings({ config, onSaved }) {
  const [s, setS] = useState(config?.sender || {});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setS(config?.sender || {});
  }, [config]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/admin/shipping/settings", { ...s, country: "FR" });
      toast.success("Adresse expéditeur enregistrée");
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const input = "h-11 w-full rounded-sm border border-[var(--line)] bg-transparent px-3 text-sm outline-none focus:border-[var(--gold)]";

  return (
    <div data-testid="admin-shipping-settings" className="grid gap-8 lg:grid-cols-2">
      <div className="space-y-4">
        <Status ok={config?.mondial_relay} label="Mondial Relay" need="login et mot de passe API V2 (code enseigne CC23JJ9G déjà enregistré)" />
        <Status ok={config?.colissimo} label="Colissimo" need="n° de contrat, mot de passe et codes produit" />
      </div>
      <form onSubmit={save} className="rounded-sm border border-[var(--line)] p-6">
        <p className="eyebrow mb-4">Adresse expéditeur (imprimée sur les étiquettes)</p>
        <div className="grid gap-3 sm:grid-cols-2">
          {FIELDS.map(([k, l]) => (
            <input key={k} data-testid={`sender-${k}`} placeholder={l} value={s[k] || ""} onChange={(e) => setS((v) => ({ ...v, [k]: e.target.value }))} className={input + (k === "street" ? " sm:col-span-2" : "")} />
          ))}
        </div>
        <button data-testid="sender-save" disabled={busy} className="mt-5 h-12 w-full rounded-full bg-[var(--gold)] text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ink)] disabled:opacity-50">Enregistrer</button>
      </form>
    </div>
  );
}
